export default process.env.NODE_ENV === 'production' ? 'https://csikszereda.verdedata.ro' : 'http://localhost:4155'
// export default process.env.NODE_ENV === 'production' ? 'https://sepsi.verdedata.ro' : 'https://10.194.250.175:4055'
